import { OrderStatus } from '@/interface/order';
import { Database } from '@/types/supabase';

export function getOrderAlphaNumber(orderNumber: number): string {
  // Obtiene el módulo 2600 del número de orden
  const modOrderNumber = orderNumber % 2600;

  // Obtiene la letra correspondiente
  const letter = getAlpha(modOrderNumber);

  // Convierte el número en string y toma los últimos dos dígitos
  const numbers = modOrderNumber.toString().slice(-2).padStart(2, '0');

  return letter + numbers;
}

export function getAlpha(orderNumber: number): string {
  // Divide el número de orden por 100 y redondea hacia abajo para obtener el índice de la letra
  const letterNumber = Math.floor(orderNumber / 100);

  // Array de letras de la A a la Z
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  // Retorna la letra correspondiente o una cadena vacía si está fuera del rango
  return letters[letterNumber] || '';
}

export function getCashNumber(orderNumber: number): string {
  // Obtiene el módulo 1000 del número de orden para permitir de 00 a 999
  const modOrderNumber = orderNumber % 1000;

  // Obtiene la letra correspondiente
  const letter = 'CASH';

  // Convierte el número en string y rellena con ceros hasta 2 dígitos. 
  // Si el número es mayor o igual a 100, se mostrará con 3 dígitos (ej: 100).
  const numbers = modOrderNumber.toString().padStart(2, '0');

  return letter + numbers;
}

export const OrderStatusText: Record<OrderStatus, string> = {
  pending: 'En preparación',
  canceled: 'Cancelado',
  ready: 'Listo para entrega',
  closed: 'Entregado',
};

export const OrderStatusProperty = ['pending', 'canceled', 'ready', 'closed'];

export const PaymentStatusText: Record<Database['public']['Enums']['payment_status'], string> = {
  pending: 'Pendiente',
  completed: 'Completado',
  canceled: 'Cancelado',
  refunded: 'Reembolsado',
  error: 'Erroneo',
};
